
import {
  computed, defineComponent, reactive,
} from 'vue';
import draggable from 'vuedraggable';
import { Modal } from 'ant-design-vue';
import Icone from '@/core/components/UI/Icone.vue';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import { IOcorrenciaArquivo } from '@/models/Entidades/IOcorrencia';
import ServicoApp from '@/servicos/ServicoApp';
import { IRespostaArquivo } from '@/core/models/IRespostaArquivo';

export default defineComponent({
  name: 'OcorrenciaArquivo',
  props: {
    arquivos: {
      type: Array as () => IOcorrenciaArquivo[],
      required: true,
    },
  },
  components: {
    Icone,
    draggable,
  },
  emits: ['update:arquivos', 'change'],
  setup(props, { emit }) {
    const servicoApp = new ServicoApp();
    const state = reactive({
      enviandoArquivos: false,
      excluindoArquivos: false,
    });

    const computedArquivos = computed({
      get: () => props.arquivos,
      set: (valor: IOcorrenciaArquivo[]) => {
        emit('update:arquivos', valor);
      },
    });

    async function removerArquivo(chamadoArquivo: IOcorrenciaArquivo) {
      state.excluindoArquivos = true;
      const index = computedArquivos.value.findIndex((c) => c.link === chamadoArquivo.link);
      if (index !== -1) {
        computedArquivos.value.splice(index, 1);
      }
      state.excluindoArquivos = false;
      emit('change');
    }

    function selecionarArquivoUpload() {
      const elemento = document.getElementById('selecionarArquivo');
      if (elemento !== null) {
        elemento.click();
      }
    }

    function isImagem(arquivo: IOcorrenciaArquivo): boolean {
      const nome = (arquivo.nome || arquivo.link || '').toLowerCase();
      return /\.(jpe?g|png|webp)$/i.test(nome);
    }

    function confirmaExclusao(chamadoArquivo: IOcorrenciaArquivo) {
      Modal.confirm({
        title: 'Você confirma a exclusão do arquivo selecionado?',
        content: '',
        okText: 'Sim',
        okType: 'danger',
        cancelText: 'Não',
        autoFocusButton: null,
        onOk: () => { removerArquivo(chamadoArquivo); },
      });
    }
    function novoArquivo(arquivo: IRespostaArquivo) {
      const chamadoArquivo:IOcorrenciaArquivo = {} as IOcorrenciaArquivo;
      chamadoArquivo.codigo = 0;
      chamadoArquivo.codigoOcorrencia = 0;
      chamadoArquivo.link = arquivo.linkArquivo;
      chamadoArquivo.data = arquivo.data;
      chamadoArquivo.nome = arquivo.arquivo;
      chamadoArquivo.tamanho = arquivo.tamanhoApresentacao;
      computedArquivos.value.push(chamadoArquivo);
      emit('change');
    }
    async function enviarArquivos(event:any) {
      if (UtilitarioGeral.validaLista(event.target.files)) {
        state.enviandoArquivos = true;
        const listaArquivos = await servicoApp.enviarVarios(event.target.files);
        listaArquivos.forEach((arquivo) => {
          if (UtilitarioGeral.valorValido(arquivo.linkArquivo)) {
            novoArquivo(arquivo);
          }
        });
      }
      state.enviandoArquivos = false;
    }

    async function dropArquivo(event:any) {
      state.enviandoArquivos = true;
      const listaArquivos = await servicoApp.enviarVarios(event.dataTransfer.files);
      listaArquivos.forEach((arquivo) => {
        if (UtilitarioGeral.valorValido(arquivo.linkArquivo)) {
          novoArquivo(arquivo);
        }
      });
      state.enviandoArquivos = false;
    }

    function change() {
      emit('change');
    }
    return {
      props,
      computedArquivos,
      state,
      dropArquivo,
      enviarArquivos,
      confirmaExclusao,
      selecionarArquivoUpload,
      isImagem,
      change,
    };
  },
});
